// extracted by mini-css-extract-plugin
export default {"creditbtn":"netbank_creditbtn__D7ONY","nbselect":"netbank_nbselect__niJdR"};